// Main Product Page Scripts

// Total Price Calculation
(function() {
  const addons = document.querySelectorAll('.addons .grid__item');
  
  if (addons.length > 0) {
    addons.forEach(function (addon) {
      const checkbox = addon.querySelector('input[type="checkbox"]');
      if (checkbox) {
        checkbox.addEventListener('change', function (e) {
          if (window.TotalPrice) {
            window.TotalPrice();
          }
        });
      }
    });
  }

  const quantityInput = document.querySelector('[name="quantity"]');
  if (quantityInput) {
    quantityInput.addEventListener('change', function () {
      if (window.TotalPrice) {
        window.TotalPrice();
      }
    });
  }

  window.TotalPrice = function () {
    let price = 0;
    const quantityInput = document.querySelector('[name="quantity"]');
    if (!quantityInput) return 0;
    
    let quantity = Number(quantityInput.value);
    
    if (addons.length > 0) {
      addons.forEach(function (addon) {
        const checkbox = addon.querySelector('input[type="checkbox"]');
        if (checkbox && checkbox.checked) {
          const priceElement = addon.querySelector('.price-item.price-item--regular');
          if (priceElement) {
            const priceText = priceElement.textContent.trim().split('₹')[1];
            if (priceText) {
              let p = Number(priceText.replace(',', ''));
              price += quantity * p;
            }
          }
        }
      });
    }

    const productPriceElement = document.querySelector('.product__price .price-item.price-item--regular');
    if (productPriceElement) {
      const productPriceText = productPriceElement.textContent.trim().split('₹')[1];
      if (productPriceText) {
        let productPrice = Number(productPriceText.replace(',', ''));
        price += quantity * productPrice;
      }
    }

    const priceDisplayElement = document.querySelector('.product__info-container .product-form__submit product-price');
    if (priceDisplayElement) {
      priceDisplayElement.innerHTML = `<span class="rupee-symbol">₹</span>${price.toLocaleString('en-IN')}`;
    }

    return price;
  };
})();

// Thumbnail Slider Center List
(function() {
  const addCenter = document.querySelectorAll('.thumbnail-list li');
  if (addCenter.length === 0) {
    const sliderButtons = document.querySelector('.slider-buttons');
    if (sliderButtons) {
      sliderButtons.classList.add('button_hide');
    }
  }
  if (addCenter.length > 14) {
    const thumbnailList = document.querySelector('.thumbnail-slider .thumbnail-list.slider');
    if (thumbnailList) {
      thumbnailList.classList.add('center_list');
    }
  }
})();



